import { get, isEmpty } from 'lodash';
import Axios from 'axios';
import { refreshTokenApi } from '../api/authSession';
import { readFudrAdminData } from '../utils/helpers';
import { SIGN_IN_SUCCESS, SUPER_ADMIN_SIGN_IN_SUCCESS } from './authentication/actionTypes';

export const resolveAuthRefreshContext = (state) => {
  const restaurantRt = get(state, 'restaurant.authData.refreshToken', '');
  const context = !isEmpty(restaurantRt) ? 'restaurant' : 'fudr';
  const refreshToken =
    context === 'restaurant' ? restaurantRt : get(state, 'fudr.authData.refreshToken', '');

  return { context, refreshToken };
};

const persistRestaurantAuthTokens = (nextAuthData) => {
  try {
    const fudrAdminData = readFudrAdminData();
    const key = get(nextAuthData, 'user.name', '');
    if (!key) return;
    const prev = fudrAdminData[key] || {};
    fudrAdminData[key] = { ...prev, authData: nextAuthData };
    localStorage.setItem('fudrAdminData', JSON.stringify(fudrAdminData));
  } catch {
    // best-effort
  }
};

export const updateAuthTokensAction =
  ({ accessToken, refreshToken, context }) =>
  async (dispatch, getState) => {
    const state = getState();
    const resolvedContext = context || resolveAuthRefreshContext(state).context;

    if (resolvedContext === 'restaurant') {
      const existingAuthData =
        get(state, 'restaurant.authData') || get(state, 'authentication.authData') || {};
      const nextAuthData = {
        ...existingAuthData,
        ...(accessToken ? { accessToken } : {}),
        ...(refreshToken ? { refreshToken } : {}),
      };
      dispatch({
        type: SIGN_IN_SUCCESS,
        authData: nextAuthData,
      });
      persistRestaurantAuthTokens(nextAuthData);
    } else {
      const existingAuthData = get(state, 'fudr.authData', {});
      const nextAuthData = {
        ...existingAuthData,
        ...(accessToken ? { accessToken } : {}),
        ...(refreshToken ? { refreshToken } : {}),
      };
      dispatch({
        type: SUPER_ADMIN_SIGN_IN_SUCCESS,
        authData: nextAuthData,
      });
    }

    if (accessToken) {
      Axios.defaults.headers.Authorization = `Bearer ${accessToken}`;
    }
  };

export const refreshTokenAction = () => async (_dispatch, getState) => {
  const state = getState();
  const { context, refreshToken } = resolveAuthRefreshContext(state);

  if (!refreshToken) {
    return { isError: true, error: new Error('Missing refresh token'), context };
  }

  try {
    const response = await refreshTokenApi(refreshToken);
    const accessToken = get(response, 'data.accessToken', '');
    const nextRefreshToken = get(response, 'data.refreshToken', '');

    if (!accessToken || !nextRefreshToken) {
      return { isError: true, error: new Error('Refresh token response missing tokens'), context };
    }

    return { accessToken, refreshToken: nextRefreshToken, context };
  } catch (error) {
    return { isError: true, error, context };
  }
};
